import React from 'react';
import type { TabsProps } from 'antd';

import StyledTabs from './styled.tsx';

export const BaseTabs: React.FC<TabsProps> = (props) => <StyledTabs {...props} />;
